import { useState, useEffect } from "react";
import { Flex, Input, InputProps, Text, } from "@chakra-ui/react";

interface InputCurrencyBRLProps extends InputProps {
  topLabel?: string;
  leftLabel?: string;
  isTransferTime?: boolean;
  isPercentage?: boolean;
  isLimit?: boolean;
  width?: string;
  height?: string;
  value?: any;
  fontSize?: string;
  isDisabled?: boolean;
  onChangeInput?: (value: string) => void;
  onEdit?: boolean;
}

export function InputCurrencyBRL({
    onChangeInput,
    isDisabled,
    topLabel,
    isTransferTime,
    isPercentage,
    isLimit,
    leftLabel,
    height,
    width,
    value,
    fontSize,
  ...rest
}: InputCurrencyBRLProps) {
  const [formattedValue, setFormattedValue] = useState<string>("");
  const [oldValue, setOldValue] = useState<string>("");





  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;

    inputValue = inputValue.replace(/[a-zA-Z]/g, "");

    if (isPercentage) {
      inputValue = inputValue.replace("%", "");
      if (Number(inputValue) > 100) {
        inputValue = "100";
      }
    } else if (isLimit) {
      let onlyNumbers = inputValue.replace(/\D/g, "");
      if (onlyNumbers === "") {
        setFormattedValue("R$ 0,00");
        return
      }
      if(Number(onlyNumbers) === 0) {
        setFormattedValue("R$ 0,00");
        return
      }
      const valueInCents = Number(onlyNumbers);
      const valueInReais = valueInCents / 100;
      let formattedValue = valueInReais.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      if (valueInCents >= 1000) {
        formattedValue = formattedValue.replace("R$ 0", "R$ ");
      }
      inputValue = formattedValue;
    } else if (isTransferTime) {
      inputValue = inputValue.replace(/[^\d]/g, "");
    }

    setFormattedValue(inputValue);
    onChangeInput?.(inputValue);
  };


  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    if (isPercentage && inputValue !== "" && !inputValue.includes("%")) {
      inputValue += "%";
    }
    setFormattedValue(inputValue);
    onChangeInput?.(inputValue);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (isPercentage && e.target.value.includes("%")) {
      e.target.value = e.target.value.replace("%", "");
    }
  };

  const maxLength = () => {
    if (isTransferTime) return 2;
    if (isPercentage) return 5;
    if (isLimit) return 15;
  };





  useEffect(() => {
    if (isLimit && value >= 0) {
      let newValue = value
      setOldValue(newValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }));
    }
    //eslint-disable-next-line
  }, [isLimit]);


  useEffect(() => {
    if (value !== undefined && value !== null) {
      let newValue = value?.toString();
       if (isLimit === true && value >= 0) {
        newValue = newValue.replace("R$", "").replace("%", "").replace(" ", "").replace(",", ".");

        let numericValue = String(value)
          .replace("%", "")
          .replace("R$", "")
          .replace(",", ".")
          .trim();

        let parsedValue = parseFloat(numericValue);

        if (!isNaN(parsedValue)) {
          newValue = parsedValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
          });
          setFormattedValue(newValue);
          onChangeInput?.(newValue);
        }
      }
      setFormattedValue(newValue);
    }
    //eslint-disable-next-line
  }, [isLimit]);





  return (
    <Flex flexDirection="column">
      <Text fontSize="12px" color="rgba(138, 148, 168, 1)" marginLeft="6px"> {topLabel}</Text>
      <Flex alignItems="center" alignContent="center" gap="8px">
        {leftLabel && <Text color="#8A94A8" fontSize="16px" lineHeight="26px" fontWeight={400}>{leftLabel}</Text>}
        <Input
          {...rest}
          maxLength={maxLength()}
          color={oldValue !== formattedValue ? "rgba(212, 136, 6, 1)" : "black"}
          isDisabled={isDisabled}
          value={formattedValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </Flex>
    </Flex>
  );
}
